<div class="At-ProfileMedia">
  <div class="At-ProfileTabContent">
    <tabset>
      <tab heading="all media" id="tab1">
        <div class="At-ProfileMediaContent">
          <ul class="At-MediaBox">
            <li>
              <figure>
                <img src="assets/images/posts/media1.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media2.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media3.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media4.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media5.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media6.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media1.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media2.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media3.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media4.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media5.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media6.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media1.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media2.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media3.jpg" alt="Media Image">
              </figure>
            </li>
          </ul>
        </div>
      </tab>
      <tab heading="saved">
        <div class="At-ProfileMediaContent">
          <ul class="At-MediaBox">
            <li>
              <figure>
                <img src="assets/images/posts/media1.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media2.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media3.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media4.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media5.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media6.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media1.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media2.jpg" alt="Media Image">
              </figure>
            </li>
            <li>
              <figure>
                <img src="assets/images/posts/media3.jpg" alt="Media Image">
              </figure>
            </li>
          </ul>
        </div>
      </tab>
    </tabset>
  </div>
</div>
